import { render, staticRenderFns } from "./CurrentOrdersPage.vue?vue&type=template&id=92699ba4&scoped=true&"
import script from "./CurrentOrdersPage.vue?vue&type=script&lang=js&"
export * from "./CurrentOrdersPage.vue?vue&type=script&lang=js&"
import style0 from "./CurrentOrdersPage.vue?vue&type=style&index=0&id=92699ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92699ba4",
  null
  
)

export default component.exports